module.exports = __webpack_public_path__ + "static/media/dashboard-on.0caf8b8d.svg";